import { Notice, Stack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { masterState } from '../../../../store/master/atom';

export const AllAdvisorsWarning: React.FC = () => {
  const { selectedPartner } = useRecoilValue(masterState);

  if (selectedPartner !== undefined && selectedPartner === 0) {
    return (
      <Stack
        mx={Spacing['inline.xxxs']}
        pt={Spacing['stack.xxxs']}
        pb={Utils.Responsive.PhoneTablet({ phone: Spacing['stack.xxxs'], tablet: 0 })}>
        <Notice
          testID="all-advisors-warning-notice"
          backgroundColor={Utils.ColorToken.WithOpacity(
            'feedback.attention.lightest',
            'opacity.medium'
          )}
          textObjects={[
            { text: 'Atenção: ', variant: 'bold' },
            {
              text: "A visualização 'Todas as filiais' não está disponível nesta tela. Selecione sua filial inicial e o assessor ao qual o cliente está alocado ou busque por algum dado do cliente no campo superior esquerdo.",
              variant: 'regular',
            },
          ]}
        />
      </Stack>
    );
  }

  return null;
};
